import { Button, Text } from "components/commons";
import styles from "../cash-noncash.module.scss";
import { dateTimeFormatV3, formatAmount } from "utils";
import locale from "localization/en";

export const expensesMapper = ({ val, onClickViewSlip }) => {
  const { expenseId, type, syncedAt, amount, remarks, imageUrl } = val;
  return {
    expenseId: (
      <>
        <Text className={styles.content}>{expenseId ?? ""}</Text>
      </>
    ),
    type: (
      <>
        <Text className={styles.content}>{type ?? ""}</Text>
      </>
    ),
    dateAndTime: (
      <>
        <Text className={styles.content}>{dateTimeFormatV3(syncedAt ?? "")}</Text>
      </>
    ),
    amount: (
      <>
        <Text className={styles.content}>{formatAmount(amount ?? 0)}</Text>
      </>
    ),
    remarks: (
      <>
        <Text className={styles.content}>{remarks ?? ""}</Text>
      </>
    ),
    receipt: (
      <>
        <Button
          style={{ textDecoration: "none", background: !imageUrl ? "none" : undefined }}
          link
          onClick={() => onClickViewSlip(imageUrl)}
          disabled={!imageUrl}
        >
          {imageUrl ? (
            locale.view
          ) : (
            <>
              <Text className={styles.blank}>{"--"}</Text>
            </>
          )}
        </Button>
      </>
    ),
  };
};
